import { RELEASE_VERSION } from '@utils/globals';

import * as effects from './effects';
import { domain } from './utils';

export const $hasNewVersion = domain.store<boolean>(false).on(effects.getVersionFx.doneData, (_, { data }) => {
	const [, version] = /RELEASE_VERSION=(.*)/.exec(data) ?? [];
	return Boolean(RELEASE_VERSION && version !== RELEASE_VERSION);
});
